import { LocalStorage } from 'quasar'
import { general } from 'src/config'

/**
 * Check if the locale is valid.
 *
 * @param {string} locale - Locale string
 *
 * @returns {boolean}
 */
function isValidLocale (locale) {
  return general.locales.some((object) => object.value === locale)
}

/**
 * Find a locale by its shorthand (e.g. 'de', 'en').
 *
 * @param {string} locale - Locale string
 *
 * @returns {Object}
 */
function findLocale (locale) {
  return general.locales.find(candidate => candidate.value === locale)
}

/**
 * Return the preferred locale based on stored locale or browser settings.
 *
 * @returns {string}
 */
function getLocale () {
  // Use locale stored in local storage
  if (LocalStorage.has('locale') && isValidLocale(LocalStorage.get.item('locale'))) {
    return LocalStorage.get.item('locale')
  }

  // Use browser settings
  if (window.navigator.language && isValidLocale(window.navigator.language.split('-')[0])) {
    return window.navigator.language.split('-')[0]
  }

  return general.default_locale
}

export { isValidLocale, findLocale, getLocale }
